import CheckmateApiClient from '../../services/apiClient';
import { IUserSettingModel } from '../../interfaces/ITask';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useUpdateUserSettingMutation = (onError?: (errorMessage: string) => void) => {
    return useMutation({
        mutationFn: async (userSetting: IUserSettingModel) => {
            const response = await _apiClient.updateUserSetting(userSetting);

            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors?.length ?? 0 > 0) {
                        throw new Error(
                            `Failed to update User Setting : ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to update User Setting');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                console.error(error.message);
                onError(error.message);
            }
        },
    });
};
